import LogoWithNameIcon from "img/logo_with_name.svg";
import { Link } from "react-router-dom";
import Notifications from "src/components/GlobalSearch/Notifications";
import { ProfilePopup } from "src/components/GlobalSearch/Profile/ProfilePopup";
import { Settings } from "src/components/GlobalSearch/Settings/Settings";

export function MobileTopBar() {
	return (
		<div className="flex items-center justify-between w-100 py-8">
			<Link to="/">
				<LogoWithNameIcon className="global-search-logo" />
			</Link>
			<div className="flex gap-8">
				<Settings />
				<Notifications />
				<ProfilePopup />
			</div>
		</div>
	);
}
